import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from 'src/app/service/snackbar.service';
import { CalendarClass } from '../class/calendar-class';
import { CalendarClassService } from '../services/calendar-class.service';
import { colorArray, ColorSet } from '../components/mkg-calendar/colors';
import { UserService } from 'src/app/service/user.service';
import { isSystemCalendarClass } from '../class/system-calendar-classes';

@Component({
  selector: 'app-calendar-class-form',
  templateUrl: './calendar-class-form.component.html',
  styleUrls: ['./calendar-class-form.component.scss']
})
export class CalendarClassFormComponent implements OnInit {

  form: FormGroup;
  isSubmitting = false;
  isEditing = false;
  isSystemClass = false;
  availableColors = colorArray;
  allUsers = []

  constructor(
    private fb: FormBuilder,
    private calendarClassService: CalendarClassService,
    private snackbarService: SnackbarService,
    private userService: UserService,
    private dialogRef: MatDialogRef<CalendarClassFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CalendarClass
  ) {
    this.form = this.fb.group({
      _id: [null],
      description: ['', [Validators.required, Validators.maxLength(100)]],
      color: [this.availableColors[0].primary, Validators.required],
      users: [[]]
    });
  }

  ngOnInit(): void {
    this.getData()

    if (this.data && this.data._id) {
      this.isEditing = true;
      this.form.patchValue(this.data);

      // A sincronização automática encontra a classe pela descrição exata, então
      // renomear desliga o sync. Cor e usuários seguem editáveis.
      this.isSystemClass = isSystemCalendarClass(this.data.description);
      if (this.isSystemClass) {
        this.form.get('description').disable();
      }
    }
  }

  async getData() {
    this.allUsers = await this.userService.getAll()
  }

  getColorName(colorValue: string): string {
    const colorSet = this.availableColors.find(c => c.primary === colorValue);
    return colorSet ? colorSet.name : '';
  }

  getSelectedColorSet(): ColorSet | undefined {
    const colorValue = this.form.get('color')?.value;
    return this.availableColors.find(c => c.primary === colorValue);
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    this.isSubmitting = true;
    // getRawValue para que a descrição desabilitada das classes do sistema
    // continue sendo enviada inalterada no update.
    const calendarClass = this.form.getRawValue();

    if (!calendarClass.users) {
      calendarClass.users = [];
    }

    if (this.isEditing) {
      this.calendarClassService.update(calendarClass).subscribe({
        next: () => {
          this.snackbarService.success('CALENDAR_CLASS.UPDATED');
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.isSubmitting = false;
          this.snackbarService.error('CALENDAR_CLASS.NOT_UPDATED');
          console.error(error);
        }
      });
    } else {
      this.calendarClassService.create(calendarClass).subscribe({
        next: () => {
          this.snackbarService.success('CALENDAR_CLASS.ADDED');
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.isSubmitting = false;
          this.snackbarService.error('CALENDAR_CLASS.NOT_ADDED');
          console.error(error);
        }
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
